/**
 * Garde d'acces basee sur le role utilisateur
 *
 * Lit le userRole depuis le session store (synchrone).
 * Gere le mode admin access via useAdminAccess.
 *
 * @module RoleBasedGuard
 * @author Equipe Brydge
 * @since 3.0.0
 */

import PropTypes from 'prop-types';
import useSessionStore from 'packages/common/stores/sessionStore';
import {usePermissions} from 'packages/common/hooks/session';
import {useAdminAccess} from 'packages/common/hooks';
import View403 from 'apps/dashboard/pages/error/view/403View';
import {SESSION_STATUS} from 'packages/common/stores/sessionStatus';

export default function RoleBasedGuard({roles, children}) {
  const status = useSessionStore((s) => s.status);
  const {userRole} = usePermissions();
  const {isAdminAccessMode} = useAdminAccess();

  // Si la session n'est pas ready (logout en cours, initialisation),
  // ne pas rediriger vers 403 — AuthGuard gere la redirection login
  if (status !== SESSION_STATUS.READY) {
    return null;
  }

  // En mode admin access, toujours autoriser
  if (isAdminAccessMode) {
    return <>{children}</>;
  }

  // Verifier les roles requis
  if (!roles || !roles.includes(userRole)) {
    return <View403 />;
  }

  return <>{children}</>;
}

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.arrayOf(PropTypes.string),
};
